/* Keep the real product form, native checkout and required photo input as source of truth. */
if (!customElements.get('sr7-mobile-purchase-bar')) {
  customElements.define('sr7-mobile-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.form = this.closest('form');
      if (!this.form) return;
      this.bound = true;
      this.media = matchMedia('(max-width: 749px)');
      this.add = this.querySelector('.sr7-purchase-bar__add');
      this.upload = this.querySelector('.sr7-purchase-bar__upload');
      this.checkoutSlot = this.querySelector('.sr7-purchase-bar__checkout');
      this.status = this.querySelector('.sr7-purchase-bar__status');
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.sync = this.sync.bind(this);
      this.upload.addEventListener('click', () => this.photo()?.click(), { signal });
      this.add.addEventListener('click', () => {
        const target = this.target();
        if (!target || target.disabled) return;
        if (!this.form.reportValidity()) {
          const invalid = Array.from(this.form.elements).find(input => input.willValidate && !input.validity.valid);
          (invalid?.closest('.product-photo-upload') || invalid)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        target.click();
      }, { signal });
      this.form.addEventListener('change', this.sync, { signal });
      document.addEventListener('change', event => {
        if (event.target.form === this.form) this.sync();
      }, { signal });
      this.media.addEventListener('change', this.sync, { signal });
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-busy', 'hidden'] });
      this.resize = new ResizeObserver(() => {
        if (this.media.matches) document.documentElement.style.setProperty('--sr7-purchase-bar-height', `${this.getBoundingClientRect().height}px`);
      });
      this.resize.observe(this);
      this.sync();
    }
    target() { return this.form.querySelector('button[ref="addToCartButton"]'); }
    photo() { return Array.from(this.form.elements).find(input => input.type === 'file' && input.required); }
    sync() {
      if (this.syncing) return;
      this.syncing = true;
      try {
        const mobile = this.media.matches;
        if (this.hidden !== !mobile) this.hidden = !mobile;
        document.documentElement.classList.toggle('sr7-purchase-bar-ready', mobile);
        const target = this.target();
        const disabled = !target || target.disabled;
        if (this.add.disabled !== disabled) this.add.disabled = disabled;
        const text = target?.querySelector('.add-to-cart-text__content')?.textContent.trim() || target?.textContent.trim() || 'Add to cart';
        if (this.add.textContent !== text) this.add.textContent = text;
        const photo = this.photo();
        if (this.upload.hidden !== !photo) this.upload.hidden = !photo;
        const file = photo?.files?.[0];
        const uploadText = file ? `Photo selected: ${file.name}` : 'Upload photo';
        if (this.upload.textContent !== uploadText) this.upload.textContent = uploadText;
        this.upload.dataset.selected = String(Boolean(file));
        if (this.status.textContent !== (file ? 'Photo selected' : '')) this.status.textContent = file ? 'Photo selected' : '';
        const checkout = this.form.querySelector('.accelerated-checkout-block');
        if (mobile && checkout && !this.checkoutSlot.contains(checkout)) {
          this.placeholder = document.createComment('SR7 original checkout location');
          checkout.before(this.placeholder);
          this.checkoutSlot.append(checkout);
        } else if (!mobile && this.placeholder && checkout && this.checkoutSlot.contains(checkout)) {
          this.placeholder.replaceWith(checkout);
          this.placeholder = null;
        }
      } finally { this.syncing = false; }
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect();
      document.documentElement.classList.remove('sr7-purchase-bar-ready');
      document.documentElement.style.removeProperty('--sr7-purchase-bar-height');
    }
  });
}
